<ng-container *ngIf="vm$ | async as vm">
	<div class="flex flex-col justify-between relative">
		<div
			*ngIf="_trustAccountId && vm.isLoading"
			class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10"
		>
			<i-tabler
				name="loader-2"
				class="animate-spin text-2xl text-green-600 z-10"
			/>
		</div>
		<div class="px-6 -mx-6 pb-4 mb-4 border-b border-gray-200">
			<div class="flex flex-row justify-between">
				<div class="align-middle items-center">
					<ui-content-header
						*ngIf="!_trustAccountId; else editTrust"
						[uiColSpan]="12"
						title="Create Trust Account"
					/>
					<ng-template #editTrust>
						<ui-content-header
							[uiColSpan]="12"
							[title]="
								'Edit Trust Account - ' + (vm.trustAccount.nickname || '')
							"
						/>
					</ng-template>
				</div>
				<ui-button icon="x" preset="ICON_DEFAULT" (click)="close()" />
			</div>
		</div>
		<div
			class="flex flex-col gap-4 grow min-w-[400px] duration-300"
			[ngClass]="{
				'pointer-events-none opacity-40': _trustAccountId && vm.isLoading,
			}"
		>
			<form
				[formGroup]="trustAccountForm"
				class="flex flex-col gap-6"
				(submit)="onFormSubmit()"
			>
				<app-input
					label="Nickname"
					name="nickname"
					[required]="true"
					formControlName="nickname"
				></app-input>
				<app-input
					label="Payee Name"
					name="trustAccountName"
					[required]="true"
					formControlName="payeeName"
				></app-input>
				<div>
					<h4>Banking Information</h4>
					<app-lender-search-input-v2
						[labelTemplate]="labelTitle"
						(onSelected)="onChangeFinancialInstitution($event)"
						[selectedInstitution]="vm.financialInstitution"
					></app-lender-search-input-v2>
					<ng-template #labelTitle>
						<h4 class="h4 mt-4">Institution *</h4>
					</ng-template>

					<h4 class="h4 mt-4">Branch *</h4>
					<div
						[ngClass]="{
							'cursor-not-allowed opacity-40 pointer-events-none':
								!vm.financialInstitution,
						}"
					>
						<app-financial-institution-branch-search
							*ngIf="!vm.trustAccount.transit; else selectedBranch"
							[financialInstitution]="vm.trustAccount"
							[mortgageeType]="mortgageeType.INSTITUTION"
							[autoComplete]="true"
							(onSelectedBranch)="onChangeBranch($event)"
							[required]="true"
						>
						</app-financial-institution-branch-search>
					</div>

					<ng-template #selectedBranch>
						<div
							class="flex gap-2 justify-between items-center py-1 px-3 pr-1 border rounded-md"
							*ngIf="selectedBranch"
						>
							<div class="flex gap-2">
								<span class="whitespace-nowrap p-sm"
									>{{ vm.trustAccount.transit }} |
								</span>
								<ui-address
									class="[&>*>*]:text-sm [&>*>*]:text-gray-600"
									type="inline"
									[address]="vm.trustAccount.address"
								/>
							</div>
							<ui-button
								icon="x"
								preset="ICON_DEFAULT"
								size="sm"
								(click)="onChangeBranch()"
							/>
						</div>
					</ng-template>
				</div>
				<div>
					<h4 class="h4 mt-4">Account Number *</h4>
					<app-input
						name="accountNumber"
						[required]="true"
						formControlName="accountNumber"
					></app-input>
				</div>
				<div>
					<h4 class="h4 mt-4">Upload Void Cheque *</h4>
					<app-file-upload
						*ngIf="!vm.voidChequeFile; else showFile"
						[required]="true"
						[fileTypes]="chequeFileTypes"
						(fileSelected)="onVoidChequeChange($event)"
					></app-file-upload>
					<ng-template #showFile>
						<div
							class="rounded-lg border p-2 flex gap-4 items-center justify-between"
						>
							<a
								externalNavInterceptor
								[href]="vm.trustAccount.voidCheque"
								target="_blank"
								class="text-green-600 hover:underline truncate max-w-250"
								>{{ vm.voidChequeFile.name }}</a
							>
							<div class="flex items-center pr-2">
								<ui-button
									icon="trash"
									preset="ICON_DEFAULT"
									size="sm"
									(click)="onVoidChequeChange()"
								/>
							</div>
						</div>
					</ng-template>
				</div>
				<div class="flex mb-20 justify-between">
					<ui-button
						*ngIf="_trustAccountId"
						[disabled]="vm.saving"
						label="Delete"
						preset="DANGER"
						(click)="onDeleteTrustAccount()"
					/>
					<ui-button
						[disabled]="vm.isDisabled"
						[loading]="vm.saving"
						type="submit"
						class="ml-auto"
						[label]="_trustAccountId ? 'Update' : 'Create'"
					></ui-button>
				</div>
			</form>
		</div>
	</div>
</ng-container>
